module.exports = __webpack_public_path__ + "static/media/Disha.9cc6ab55.jpg";